import React, { useState, useEffect } from 'react'
import { Form, Input, Button, Checkbox, message, Row, Col, } from 'antd'
import { connect } from 'react-redux'
import md5 from "md5"
import api from '@api/login'
import { success } from '@store/actions/common'
import Icon1 from '../../assets/logo2.png'
import jiurui from './img/JIURUI CLOUD@2x.png'
import './index.scss'

const tailLayout = {
  wrapperCol: { offset: 0, span: 24 },
};

const Login = ({ history, userInfo, dispatch }) => {
  const [loading, setLoading] = useState(false)

  const onFinish = values => {
    setLoading(true)
    api.loginCheck({ userName: values.userName }).then(res => {
      if (res.status * 1 === 0 && res.data.length > 0) {
        let payload = {
          tenantId: res.data[0].tenantId,
          password: md5(values.password),
          userName: values.userName,
          prefix: 'wxb'
        }
        sessionStorage.setItem('TENANT-ID', res.data[0].tenantId);
        sessionStorage.setItem('DATA-NODE', res.data[0].dataNode);
        return payload
      } else {
        setLoading(false)
        message.error('账户不存在，请联系管理员')
        return false
      }
    })
      .then(params => {
        if (params) {
          api.login(params).then(res => {
            setLoading(false)
            if (res.status == 0) {
              let { data } = res;
              sessionStorage.setItem('userInfo', JSON.stringify(data))
              sessionStorage.setItem('token', data.token)
              dispatch(success(data));
              history.replace('/stationManagement/factoryProgress')
            }
          })
        }
      })
  };

  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo);
  };

  return (
    <div className='main'>
      <div className='loginWrap'>
        <div className='form'>
          <div className='login-logo'>
            {/* <img src={Icon1} style={{ width: '158px' }} /> */}
          </div>
          
          <div className='sys-name'>绵阳智慧化循环利用污水处理</div>
          <Row span={24}>
            <p className='p'>账号</p>
            <p className='p' style={{ marginLeft: '24px' }}>密码</p>
          </Row>
          <Form
            name="basic"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Row span={24}>
              <Form.Item
                name="userName"
                rules={[{ required: true, message: '请输入用户名!' }]}
                style={{ marginLeft: '2px' }}
              >
                <Input className='input' placeholder={'请输入用户名'} />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[{ required: true, message: '请输入密码!' }]}
                style={{ marginLeft: '24px' }}
              >
                <Input.Password className='input pinput' placeholder={'请输入密码'} />
              </Form.Item>
            </Row>

            <Form.Item {...tailLayout}    >
              <Button className='loginBtn' type="primary" htmlType="submit" loading={loading}>
                登录
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
      <div className='backImg'>
        {/* <div className='jiurui'><img src={jiurui}></img></div> */}
        <div className='twop'>
          <p>分散式污水智慧化管控平台</p>
          <p>站点远程360°监控、智能巡检、智能预警、资产管理、数据分析。</p>
        </div>
      </div>
    </div>
  )
}
const mapStateToProps = state => {
  return {
    ...state.Common
  }
};
export default connect(mapStateToProps)(Login)
